<div class="modal-header">
    <h4 class="modal-title pull-left">Approve / Reject</h4>
    <button type="button" class="close" aria-label="Close" (click)="bsModalRef?.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <section class="prInitiator">
        <div class="d-flex flex-column mb-4 mt-1">
            <ng-container>
                <form [formGroup]="statusForm" class="p-4">
                    <div class="row">
                        <label for="remarks" class="form-label text-small">Remarks</label>
                        <input type="text" name="remarks" [(ngModel)]="remarks" class="form-control" [error]="statusForm.get('remarks')">
                    </div>
                </form>
            </ng-container>
        </div>
    </section>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary me-2" (click)="updateQESStatus('APPROVED')">
        Approve
    </button>
    <button type="button" class="btn btn-danger me-2" (click)="updateQESStatus('REJECTED')">
        Reject
    </button>
</div>